import {hideError, hideErrorMessage, showError} from "../actions/actions";
import axios from "axios";
import {API_URL} from "../config";
import {
    GET_NOTIFICATION_ERROR,
    SHOW_GET_COMPANIES_DIRECTORIES_TRANKS_PHONE_ERROR
} from "../types/types";
import {showAccessDeniedNotifications} from "../actions/actionsNotifications";
import {
    GET_ALL_QUEUES, GET_IVR_CONFIGURATION,
    GET_QUEUE,
    GET_QUEUE_DIRECTORIES_QUEUE_DIRECTIONS_TYPE,
    GET_QUEUE_DIRECTORIES_QUEUE_OPERATORS_TYPE,
    GET_QUEUE_DIRECTORIES_QUEUE_TYPE,
    GET_QUEUE_DIRECTORIES_DICTIONARY_700,
    GET_QUEUE_DIRECTORIES_TRANKS_PHONE,
    GET_QUEUE_PAGINATION,
    GET_QUEUES,
    SHOW_QUEUE_DETAIL_LOADING
} from "../types/typesQueue";
import {setQueueErrorField, showQueueLoader} from "../actions/actionsQueue";
import {getAllAudio} from "./apiAudio";
import {fetchTrunksPhonesCatalog} from "./sharedCatalogRequests";
import {SET_USER_STATUS_ERROR, SET_USER_STATUS_SUCCESS} from "../types/typesUsersList";
import {setStatusDialogVisible} from "../actions/actionsStatuses";
import {getBranchDetailById} from "./apiBranchList";
import {
    GET_CALL_RESET_DICTIONARY,
    GET_CALL_TYPE_DICTIONARY,
    GET_FORCED_CLOSING_DICTIONARY, GET_OWNER_TYPE_DICTIONARY, GET_STATUS_DICTIONARY
} from "../types/typesMonitoringList";


function isServerFailureStatus(statusCode: unknown) {
    return typeof statusCode === 'number' && statusCode >= 500;
}

let dataSort = {
    isArchived: false,
    pageNumber: 1,
    pageSize: 10,
    sort: {
        orderBy: "Id",
        isDesc: true
    }
}

export function getAllQueuesWithPagination(data: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(showQueueLoader(true))
        dispatch(hideError())
        axios.post(`${API_URL}Queues/GetAllQueuesWithPagination`, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dataSort = data;
                if (data.isArchived === false) {
                    dispatch({type: GET_QUEUES, payload: response.data.data.items})
                } else {
                    dispatch({type: GET_QUEUES, payload: response.data.data.items})
                }
                dispatch({type: GET_QUEUE_PAGINATION, payload: response.data.data})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch(showQueueLoader(false));
                dispatch(hideError());
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function getQueueId(id: number, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch({type: SHOW_QUEUE_DETAIL_LOADING, payload: true});
        dispatch(hideError());
        axios.get(`${API_URL}Queues/GetQueueById?queueId=${id}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (isServerFailureStatus(response.data?.statusCode)) {
                    dispatch(showError());
                    return;
                }
                dispatch({type: GET_QUEUE, payload: response.data.data})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SHOW_QUEUE_DETAIL_LOADING, payload: false});
            })
    }
}

export function createQueue(data: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(setQueueErrorField(null));
        dispatch(hideError());
        axios.post(`${API_URL}Queues/CreateQueue`, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: GET_QUEUE, payload: response.data.data})
                    dispatch(getAllQueuesWithPagination(dataSort, jwtToken));
                    dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                } else if (response.data.statusCode === 400) {
                    dispatch(setQueueErrorField({"nameUniq": "Назва черги вже існує"}));
                } else if (isServerFailureStatus(response.data?.statusCode)) {
                    dispatch(showError());
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload: {message: response.data.message}})
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function updateQueue(data: any, jwtToken: any, branchId?: number) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(setQueueErrorField(null));
        dispatch(hideError());
        axios.put(`${API_URL}Queues/UpdateQueue`, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: GET_QUEUE, payload: response.data.data})
                    dispatch(getAllQueuesWithPagination(dataSort, jwtToken));
                    dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                    if (branchId) {
                        dispatch(getBranchDetailById(branchId, jwtToken));
                    }
                } else if (response.data.statusCode === 400) {
                    dispatch(setQueueErrorField({"nameUniq": "Назва черги вже існує"}));
                } else if (isServerFailureStatus(response.data?.statusCode)) {
                    dispatch(showError());
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload: {message: response.data.message}})
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

function extractIvrConfigurationsList(payload: any): any[] {
    if (Array.isArray(payload)) {
        return payload;
    }
    if (Array.isArray(payload?.items)) {
        return payload.items;
    }
    if (Array.isArray(payload?.Items)) {
        return payload.Items;
    }
    if (Array.isArray(payload?.data)) {
        return payload.data;
    }
    return [];
}

function normalizeIvrId(value: any) {
    if (value == null || value === '') {
        return value;
    }
    const numeric = Number(value);
    return Number.isFinite(numeric) ? numeric : value;
}

export function buildIvrDropdownOptions(dictionary: any, selectedId?: any, selectedName?: string) {
    const list = Array.isArray(dictionary) ? dictionary : [];
    const options = list
        .map((item: any) => {
            const flowId = normalizeIvrId(item?.flowId ?? item?.id);
            const name = item?.name ?? '';
            return {
                ...item,
                flowId,
                name,
                label: [flowId, name].filter((part) => part != null && String(part).trim() !== '').join(' '),
            };
        })
        .filter((item: any) => item.flowId != null && item.flowId !== '');

    const currentId = normalizeIvrId(selectedId);
    if (currentId != null && currentId !== '' && !options.some((item: any) => String(item.flowId) === String(currentId))) {
        options.unshift({
            flowId: currentId,
            name: selectedName || String(currentId),
            label: [currentId, selectedName].filter((part) => part != null && String(part).trim() !== '').join(' '),
        });
    }
    return options;
}

export function getQueueIVRType(jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError());
        axios.get(`${API_URL}IVRConfig/GetIvrConfigurations`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dispatch({
                    type: GET_IVR_CONFIGURATION,
                    payload: extractIvrConfigurationsList(response.data?.data ?? response.data),
                })
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError());
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function setArchiveQueueById(id: number, jwtToken: any, sort?: any) {
    return (dispatch: (arg0: any) => void) => {
        axios.post(`${API_URL}Queues/ArchiveOrUnArchiveQueue?queueId=${id}`, {}, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`,
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                    dispatch(getAllQueuesWithPagination(sort || dataSort, jwtToken));
                    dispatch(setStatusDialogVisible(false));
                } else if (isServerFailureStatus(response.data?.statusCode)) {
                    dispatch(showError());
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload: {message: response.data.message}})
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
            })
    }
}

export function getQueueDirectoriesQueueAudioType(jwtToken: any) {
    return getAllAudio(jwtToken);
}

export function copyQueueById(queueId: number, jwtToken: any, sort?: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError());
        axios.get(`${API_URL}Queues/CopyQueue/${queueId}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                    dispatch(getAllQueuesWithPagination(sort || dataSort, jwtToken));
                } else if (isServerFailureStatus(response.data?.statusCode)) {
                    dispatch(showError());
                } else {
                    dispatch(getAllQueuesWithPagination(sort || dataSort, jwtToken));
                    dispatch({type: SET_USER_STATUS_ERROR, payload: {message: response.data.message}})
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
            })
    }
}

export function getQueueDirectoriesGetTranksPhones(jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError())
        dispatch(hideErrorMessage())
        dispatch({type: SHOW_GET_COMPANIES_DIRECTORIES_TRANKS_PHONE_ERROR, payload: false})
        return fetchTrunksPhonesCatalog(jwtToken)
            .then((data) => {
                dispatch({type: GET_QUEUE_DIRECTORIES_TRANKS_PHONE, payload: data})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    return dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch({type: SHOW_GET_COMPANIES_DIRECTORIES_TRANKS_PHONE_ERROR, payload: true})
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function getAllQueues(jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError())
        dispatch(hideErrorMessage())
        axios.get(`${API_URL}Queues/GetAllQueues?isArchived=false&isActive=true`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dispatch({type: GET_ALL_QUEUES, payload: response.data.data})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    return dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError());
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}


function getDictionariesByParentId(data: any[], parentId: any, options = { onlyActive: true }) {
    return data?.filter(item =>
        item.parentId === parentId &&
        (options.onlyActive ? item.isActive : true)
    );
}

export function getVoipDictionary(jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError());
        axios.post(`${API_URL}VoipDictionary/GetDictionaries/true`, [10, 20, 30, 100, 200, 300, 500, 600, 700], {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                const allItems10 = getDictionariesByParentId(response.data?.data, 10, { onlyActive: false });
                const allItems20 = getDictionariesByParentId(response.data?.data, 20, { onlyActive: false });
                const allItems30 = getDictionariesByParentId(response.data?.data, 30, { onlyActive: false });
                const allItems100 = getDictionariesByParentId(response.data?.data, 100, { onlyActive: false });
                const allItems200 = getDictionariesByParentId(response.data?.data, 200, { onlyActive: false });
                const allItems300 = getDictionariesByParentId(response.data?.data, 300, { onlyActive: false });
                const allItems500 = getDictionariesByParentId(response.data?.data, 500, { onlyActive: false });
                const allItems600 = getDictionariesByParentId(response.data?.data, 600, { onlyActive: false });
                const allItems700 = getDictionariesByParentId(response.data?.data, 700, { onlyActive: false });

                dispatch({type: GET_CALL_RESET_DICTIONARY, payload: allItems10});
                dispatch({type: GET_FORCED_CLOSING_DICTIONARY, payload: allItems20});
                dispatch({type: GET_OWNER_TYPE_DICTIONARY, payload: allItems30});
                dispatch({type: GET_QUEUE_DIRECTORIES_QUEUE_TYPE, payload: allItems200});
                dispatch({type: GET_QUEUE_DIRECTORIES_QUEUE_OPERATORS_TYPE, payload: allItems300});
                dispatch({type: GET_QUEUE_DIRECTORIES_QUEUE_DIRECTIONS_TYPE, payload: allItems500});
                dispatch({type: GET_CALL_TYPE_DICTIONARY, payload: allItems600});
                dispatch({type: GET_QUEUE_DIRECTORIES_DICTIONARY_700, payload: allItems700});
                dispatch({type: GET_STATUS_DICTIONARY, payload: allItems100})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError());
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

